<template>
<div>
  <template v-if="withLocationFilter" >
    <v-card-title class="caption" >
      <v-spacer/>
      Filter by location:
      <v-chip label outlined x-small
        v-for="location in locations" :key="location.id"
        @click="toggleLocationFilter(location.id)" class="mr-2" >
        <v-icon v-if="isSelectedLocation(location.id)" x-small left >mdi-check</v-icon>
        {{location.name}}
      </v-chip>
    </v-card-title>
    <v-divider class="my-3" />
  </template>
  <template v-if='chips' >
    <v-chip-group column active-class="primary"
      v-model="selected"
      :multiple="multiple" >
      <template v-for='product in products' >
        <!-- <pre v-text="product" :key='product.id'  /> -->
        <v-chip :small="dense"
          :key='product.id'
          :value='getValue(product)' >{{product.title}}</v-chip>
      </template>
      <slot name="chips-after" ></slot>
    </v-chip-group>
  </template>
  <v-select v-else
    v-model='selected'
    :label='label'
    :return-object='returnObject'
    :multiple='multiple'
    :dense='dense'
    v-bind='attrs'
    :items='products'
    item-value='id'
    item-text='title' />
</div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'ProductPicker',
  props: {
    practitionerId: { required: false },
    spaceId: { required: false },
    returnObject: {type: Boolean, default: true},
    multiple: {type: Boolean, default: true},
    chips: {type: Boolean, default: false},
    dense: {type: Boolean, default: true},
    withLocationFilter: {type: Boolean, default: false},
    attrs: { type: Object, required: false }
  },
  data () {
    return {
      selected: null,
      locationFilter: []
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    }
  },
  methods: {
    getValue (product) {
      if (this.returnObject) { return product }
      return product.id
    },
    isSelectedLocation (locationId) {
      return (this.locationFilter.indexOf(locationId) !== -1)
    },
    toggleLocationFilter (locationId) {
      const index = this.locationFilter.indexOf(locationId)
      if (index === -1) {
        this.locationFilter.push(locationId)
      } else {
        this.locationFilter.splice(index, 1)
      }
    }
  },
  computed: {
    ...mapGetters ('identity', ['getProducts', 'productsList']),
    products () {
      let options = {
        spaceId: this.spaceId,
        practitionerId: this.practitionerId
      }
      let products = this.getProducts(options)
      // if (this.locationFilter && this.locationFilter.length > 0) {
      //   const ps = []
      //   this.products.forEach((p) => {
      //     if (p.locationIds.indexOf())
      //   })
      // }
      return products
    },
    locations () {
      const locSet = new Set()
      const locs = []
      this.products.forEach((product) => {
        if (product.locations) {
          product.locations.forEach((l) => {
            if (!locSet.has(l.id)) {
              locs.push(l)
            }
            locSet.add(l.id)
          })
        }
      })
      return locs
    },
    label () {
      return 'Choose an appointment type'
    }
  }
}
</script>
